export default __webpack_public_path__ + "static/business_bg-96a590a503f2ce5f3d8a5f73378b0b2c.jpg";